<div class="h-full flex flex-col justify-start items-center overflow-hidden space-y-4">
    <!-- Header -->
    <div class="flex-0 flex flex-row items-center justify-between w-full border-b border-zinc-200 dark:border-zinc-800 pb-4">
        <div>
            <h2 class="text-base/7 font-semibold text-primary">Token & Feature Usage</h2>
            <p class="text-sm/6 text-secondary">Monitor your token consumption and feature usage across all services.</p>
        </div>
    </div>
    <!-- Header - END -->

    <!-- Content -->
    <div class="flex-1 w-full overflow-y-auto scrollbar-transparent">
        <div class="space-y-6">
            
            <!-- AI Content Reviews -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex items-center gap-x-3 mb-4">
                    <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-accent/90">
                            <path d="M12 2v20M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-sm font-semibold text-primary">AI Content Reviews</h3>
                        <p class="text-xs text-secondary">Automated content analysis and moderation</p>
                    </div>
                </div>
                <dl class="grid grid-cols-1 gap-4 sm:grid-cols-4">
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Tokens Used</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">12,450</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Reviews Completed</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">342</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Avg. Tokens/Review</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">36</dd>
                        <dd class="text-xs text-secondary mt-1">Per review</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-emerald-50 dark:bg-emerald-500/10 px-4 py-3 border border-emerald-200 dark:border-emerald-500/20">
                        <dt class="truncate text-xs font-medium text-secondary">Tokens Remaining</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-emerald-600 dark:text-emerald-400">37,550</dd>
                        <dd class="text-xs text-secondary mt-1">Before purchase needed</dd>
                    </div>
                </dl>
            </div>

            <!-- Creator Screening -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex items-center gap-x-3 mb-4">
                    <div class="size-10 rounded-full bg-emerald-100 dark:bg-emerald-500/20 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-emerald-700 dark:text-emerald-300">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                            <circle cx="9" cy="7" r="4" />
                            <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-sm font-semibold text-primary">Creator Screening</h3>
                        <p class="text-xs text-secondary">Content analysis and creator evaluation</p>
                    </div>
                </div>
                <dl class="grid grid-cols-1 gap-4 sm:grid-cols-4">
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Tokens Used</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">8,920</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Creators Screened</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">127</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Avg. Tokens/Creator</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">70</dd>
                        <dd class="text-xs text-secondary mt-1">Per screening</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-emerald-50 dark:bg-emerald-500/10 px-4 py-3 border border-emerald-200 dark:border-emerald-500/20">
                        <dt class="truncate text-xs font-medium text-secondary">Tokens Remaining</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-emerald-600 dark:text-emerald-400">41,080</dd>
                        <dd class="text-xs text-secondary mt-1">Before purchase needed</dd>
                    </div>
                </dl>
            </div>

            <!-- Social Monitoring -->
            <div class="rounded-lg bg-white/60 dark:bg-white/5 p-4 outline-1 -outline-offset-1 outline-zinc-200 dark:outline-white/10">
                <div class="flex items-center gap-x-3 mb-4">
                    <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-accent">
                            <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-sm font-semibold text-primary">Social Monitoring</h3>
                        <p class="text-xs text-secondary">Real-time social media tracking and alerts</p>
                    </div>
                </div>
                <dl class="grid grid-cols-1 gap-4 sm:grid-cols-4">
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Tokens Used</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">15,680</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Posts Monitored</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">2,341</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-gray-50 dark:bg-gray-800/50 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Avg. Tokens/Post</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-primary">7</dd>
                        <dd class="text-xs text-secondary mt-1">Per post</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-emerald-50 dark:bg-emerald-500/10 px-4 py-3 border border-emerald-200 dark:border-emerald-500/20">
                        <dt class="truncate text-xs font-medium text-secondary">Tokens Remaining</dt>
                        <dd class="mt-1 text-2xl font-semibold tracking-tight text-emerald-600 dark:text-emerald-400">34,320</dd>
                        <dd class="text-xs text-secondary mt-1">Before purchase needed</dd>
                    </div>
                </dl>
            </div>

            <!-- Summary Card -->
            <div class="rounded-lg bg-primary/10 dark:bg-primary/10 p-4 outline-1 -outline-offset-1 outline-primary/25 dark:outline-primary/20">
                <div class="flex items-center gap-x-3 mb-4">
                    <div class="size-10 rounded-full bg-primary/10 dark:bg-primary/20 flex items-center justify-center">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 text-accent/90">
                            <path d="M3 3v18h18" />
                            <path d="M18 7H9" />
                            <path d="M13 12H9" />
                            <path d="M17 17H9" />
                        </svg>
                    </div>
                    <div>
                        <h3 class="text-sm font-semibold text-primary">Total Usage Summary</h3>
                        <p class="text-xs text-secondary">Combined usage across all features</p>
                    </div>
                </div>
                <dl class="grid grid-cols-1 gap-4 sm:grid-cols-3">
                    <div class="overflow-hidden rounded-lg bg-white/60 dark:bg-white/5 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Total Tokens Used</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-primary">37,050</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-white/60 dark:bg-white/5 px-4 py-3">
                        <dt class="truncate text-xs font-medium text-secondary">Total Operations</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-primary">2,810</dd>
                        <dd class="text-xs text-secondary mt-1">This month</dd>
                    </div>
                    <div class="overflow-hidden rounded-lg bg-emerald-50 dark:bg-emerald-500/10 px-4 py-3 border border-emerald-200 dark:border-emerald-500/20">
                        <dt class="truncate text-xs font-medium text-secondary">Total Tokens Remaining</dt>
                        <dd class="mt-1 text-3xl font-semibold tracking-tight text-emerald-600 dark:text-emerald-400">112,950</dd>
                        <dd class="text-xs text-secondary mt-1">Before purchase needed</dd>
                    </div>
                </dl>
            </div>

        </div>
    </div>
    <!-- Content - END -->
</div>
